import { Button, Form, Space, Typography } from "antd";
import { useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import AppContent from "../../../common/AppContent";

import FilterComponent from "components/Configuration/CommonComponents/FilterComponent";
import { NO_PERMISSION_REQUIRED } from "routes/permissions";
import { hasPermission } from "utils/functions";
import AppPageHeader from "../../../common/PageHeader";
import FinishingLineList from "./FinishingLineList";

const FinishingLine = () => {
  // Router
  const location = useLocation();
  const routerPath = location ? location.pathname : null;

  // States
  const [tableData, setTableData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [metaData, setMetaData] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [showFilter, setShowFilter] = useState(
    localStorage.getItem("filter_status") && routerPath
      ? JSON.parse(localStorage.getItem("filter_status"))[routerPath]
      : false,
  );
  const [refresh, setRefresh] = useState(0);

  // Antd
  const { Title } = Typography;
  const [form] = Form.useForm();

  // Initialize form with default values
  const formInitialValues = {
    name: "Line-1",
    status: 1,
  };

  const refetch = () => {
    setRefresh(refresh + 1);
    form.resetFields();
  };

  const handleAddNew = () => {
    setSelectedRecord(null);
    setIsEdit(false);
    setIsModalOpen(true);
    // Set default values when opening the form
    form.setFieldsValue(formInitialValues);
  };

  // Add form reset function
  const handleFormReset = () => {
    setIsModalOpen(false);
    setIsEdit(false);
    setSelectedRecord(null);
    refetch(); // Refresh the data after add/edit
  };

  // Function to fetch table data with filters
  const fetchTableList = (filterParams) => {
    // This function will be implemented to fetch data with filters
    // For now it just refreshes the data
    setCurrentPage(1);
    refetch();
  };

  // Memoized filter component to prevent unnecessary re-renders
  const memoizedCustomFilter = useMemo(
    () => (
      <FilterComponent
        tableData={tableData}
        filterAPI={fetchTableList}
        showFilter={showFilter}
        setShowFilter={setShowFilter}
        filterName="digitalization_finishing_line" // Changed to match this component
      />
    ),
    [showFilter, tableData],
  );

  return (
    <>
      <AppContent
        header={
          <AppPageHeader
            extra={
              <Space>
                <Button
                  type={showFilter ? "danger" : "primary"}
                  size="small"
                  onClick={() => setShowFilter((prev) => !prev)}
                  style={{ float: "right" }}
                >
                  {`${showFilter ? "Close" : "Open"} Filter Option`}
                </Button>
                <Button
                  key="3"
                  size="small"
                  type="primary"
                  disabled={!hasPermission([NO_PERMISSION_REQUIRED])}
                  onClick={handleAddNew}
                >
                  {hasPermission([NO_PERMISSION_REQUIRED])
                    ? "Add New"
                    : "No Permission"}
                </Button>
              </Space>
            }
            title={<Title level={5}>Finishing Line</Title>}
          />
        }
        content={
          <>
            {/* Display the filter component when showFilter is true */}
            {memoizedCustomFilter}

            <FinishingLineList
              form={form}
              showFilter={showFilter}
              setShowFilter={setShowFilter}
              refresh={refresh}
              refetch={refetch}
              tableData={tableData}
              setTableData={setTableData}
              loading={loading}
              setLoading={setLoading}
              metaData={metaData}
              setMetaData={setMetaData}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              isModalOpen={isModalOpen}
              setIsModalOpen={setIsModalOpen}
              isEdit={isEdit}
              setIsEdit={setIsEdit}
              selectedRecord={selectedRecord}
              setSelectedRecord={setSelectedRecord}
              handleFormReset={handleFormReset}
              formInitialValues={formInitialValues}
              fetchTableList={fetchTableList}
            />
          </>
        }
      />
    </>
  );
};

export default FinishingLine;
